import { analyticsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { getUuid } from 'store/auth/selectors';

import { normalizeGraphicsData } from './utils';

export const ANALYTICS_REPORTS_ACTION_TYPE = createNamedActions('analytics-reports', {
  GET_COMPANY_REPORTS: 'GET_COMPANY_REPORTS',
  GET_USER_REPORTS: 'GET_USER_REPORTS',
  GET_REPORT_EMBED_LINK: 'GET_REPORT_EMBED_LINK',
  SET_SELECTED_REPORTS_BY_ROLE: 'SET_SELECTED_REPORTS_BY_ROLE',
  RESET_REPORTS_STATE: 'RESET_REPORTS_STATE',
});

export const getCompanyReportsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await analyticsApi.getReports();

  return dispatch({
    type: ANALYTICS_REPORTS_ACTION_TYPE.GET_COMPANY_REPORTS,
    payload: normalizeGraphicsData(data),
  });
});

export const getUserReportsAction = catchAsyncActionError(() => async (dispatch, getState) => {
  const userId = getUuid(getState());

  const { data } = await analyticsApi.getReportsByUserId(userId);

  return dispatch({
    type: ANALYTICS_REPORTS_ACTION_TYPE.GET_USER_REPORTS,
    payload: normalizeGraphicsData(data),
  });
});

export const getReportEmbedLinkAction = catchAsyncActionError(reportId => async dispatch => {
  const { data } = await analyticsApi.getReportEmbedLinkByReportId(reportId);

  return dispatch({
    type: ANALYTICS_REPORTS_ACTION_TYPE.GET_REPORT_EMBED_LINK,
    payload: data,
  });
});

export const setSelectedReportsByRoleActionV2 = catchAsyncActionError(
  ({ dataToSave, dataToStore }) =>
    async dispatch => {
      await analyticsApi.setSelectedReports(dataToSave);

      return dispatch({
        type: ANALYTICS_REPORTS_ACTION_TYPE.SET_SELECTED_REPORTS_BY_ROLE,
        payload: dataToStore,
      });
    },
);

export const resetReportsStateAction = () => ({
  type: ANALYTICS_REPORTS_ACTION_TYPE.RESET_REPORTS_STATE,
});
